import { Box, Typography } from '@mui/material'
import { leadershipIntro } from '../../data/leadershipContent'

export default function LeadershipIntroSection() {
  return (
    <Box
      component="section"
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: 'center',
        gap: { xs: 4, md: 6, lg: '115px' },
        width: '100%',
      }}
    >
      <Box
        sx={{
          position: 'relative',
          width: { xs: '100%', md: 400, lg: 667 },
          maxWidth: { md: 400, lg: 667 },
          height: { xs: 300, sm: 380, md: 400, lg: 480 },
          borderRadius: '20px',
          overflow: 'hidden',
          flexShrink: 0,
        }}
      >
        <Box
          component="img"
          src={leadershipIntro.image}
          alt="Leadership development participant"
          sx={{
            position: 'absolute',
            left: 0,
            width: '100%',
            height: '261.57%',
            top: '-55.6%',
            maxWidth: 'none',
            display: 'block',
          }}
        />
      </Box>

      <Typography
        sx={{
          flex: 1,
          fontSize: { xs: 18, sm: 20, lg: 24 },
          lineHeight: 'normal',
          fontWeight: 400,
          color: '#111',
        }}
      >
        {leadershipIntro.text}
      </Typography>
    </Box>
  )
}
